import { AuthUserHook } from '@/models/hooks.ts';

import { signOut as serviceSignOut } from '@/services/auth-service.ts';
import { showErrorNotification } from '@/services/notification-service.ts';

import { useAuthStore } from '@/stores/auth-store.ts';
import { useConfigStore } from '@/stores/config-store.ts';

const signOut = async (): Promise<void> => {
    try {
        await serviceSignOut();
    } catch {
        showErrorNotification('Abmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.');
    } finally {
        useAuthStore.getState().reset();
        useConfigStore.getState().reset();
    }
};

export const useAuth = (): AuthUserHook => {
    const {
        user: authUser,
        isAdmin,
        userEmail: email,
        userScopes: scopes,
        userGroups: groups,
        userInstanceIds: instanceIds,
        userCustomerIds: customerIds,
        userLocationIds: locationIds,
        userPracticeIds: practiceIds,
        userMapPractitionerId: mapPractitionerId,
        pictureUrl,
    } = useAuthStore((state) => state);

    const isUserInGroup = (groupsToCheck: string | string[]): boolean => {
        if (isAdmin) return true;

        const groupsArray: string[] = Array.isArray(groupsToCheck) ? groupsToCheck : [groupsToCheck];
        const userGroupsSet = new Set(groups);

        return groupsArray.some((group) => userGroupsSet.has(group));
    };

    return {
        authUser,
        isAdmin,
        email,
        scopes,
        groups,
        instanceIds,
        customerIds,
        locationIds,
        practiceIds,
        mapPractitionerId,
        pictureUrl,
        isUserInGroup,
        signOut,
    };
};
